import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import user from './modules/user'
import app from './modules/app'

const parseStorageJSON = (key, fallback) => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return fallback
  }
  try {
    const value = localStorage.getItem(key)
    return value ? JSON.parse(value) : fallback
  } catch (error) {
    return fallback
  }
}

const _host = (typeof window !== 'undefined' && window.httphost) || { publicurl: '', recordInfo: [] }
const _protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:'
export default new Vuex.Store({
  state: {
    _host: _host,
    resourcesUrl: _protocol + '//' + _host.publicurl,
    fileUploadUrl: _protocol + '//' + _host.publicurl,
    permissionMenus: parseStorageJSON('admin_permission_menus', []),
    activeNav: (typeof window !== 'undefined' && window.localStorage && localStorage.getItem('admin_active_nav')) || '',
    menuIndex: Number((typeof window !== 'undefined' && window.localStorage && localStorage.getItem('admin_menu_index')) || 0),
  },

  mutations: {
    ADD_ROUTES(state, menus = []) {
      state.permissionMenus = Array.isArray(menus) ? menus : []
      localStorage.setItem('admin_permission_menus', JSON.stringify(state.permissionMenus))
    },

    ACTIVE_NAV(state, path = '') {
      state.activeNav = path
      localStorage.setItem('admin_active_nav', path)
    },

    setMenuIndex(state, index = 0) {
      state.menuIndex = Number(index) || 0
      localStorage.setItem('admin_menu_index', String(state.menuIndex))
    },

    setUserInfo(state, userInfo = {}) {
      const token = userInfo.token || ''
      const user = userInfo.user || {}
      state.user.token = token
      state.user.userInfo = user
      localStorage.setItem('token', token)
      localStorage.setItem('userInfo', JSON.stringify(user))
    },

    clearUserInfo(state) {
      state.user.token = ''
      state.user.userInfo = {}
      state.permissionMenus = []
      state.activeNav = ''
      state.menuIndex = 0
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('qd')
      localStorage.removeItem('admin_permission_menus')
      localStorage.removeItem('admin_active_nav')
      localStorage.removeItem('admin_menu_index')
    },
  },

  modules: {
    user,
    app,
  },
})
